import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["overlay", "iframe"]
    static values = {
        url: String
    }

    disconnect() {
        this.close()
    }

    open() {
        // Load the game only when opened, so it does not run (or play sound) in the background
        this.iframeTarget.src = this.urlValue
        this.overlayTarget.setAttribute("aria-hidden", "false")
        document.body.style.overflow = "hidden"
    }

    close() {
        if (this.overlayTarget.getAttribute("aria-hidden") === "true") return

        this.overlayTarget.setAttribute("aria-hidden", "true")
        // Unload the game to stop its loop and sound
        this.iframeTarget.src = "about:blank"
        document.body.style.overflow = ""
    }
}
